import React from 'react';

class ComparisonTable extends React.Component {
	render() {
		return (
			<div className="fullwidth light">
				<div className="row">
					<div className="twelve columns text-center">
						<h2>Why Choose Confidential Servers?</h2>
						<p style={{fontSize: '1.1em', marginBottom: '40px'}}>Built on a zero-trust model where even the host is not trusted</p>
					</div>
				</div>
				<div className="row">
					<div className="twelve columns">
						<div className="panel">
							<table style={{width: '100%', borderCollapse: 'collapse'}}>
								<thead>
									<tr style={{backgroundColor: '#2d2d2d', color: '#fff'}}>
										<th style={{padding: '15px', textAlign: 'left', border: '1px solid #ddd'}}>Feature</th>
										<th style={{padding: '15px', textAlign: 'center', border: '1px solid #ddd'}}>Confidential Server</th>
										<th style={{padding: '15px', textAlign: 'center', border: '1px solid #ddd'}}>Standard VPS</th>
										<th style={{padding: '15px', textAlign: 'center', border: '1px solid #ddd'}}>Dedicated Server</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td style={{padding: '12px', border: '1px solid #ddd', fontWeight: 'bold'}}>Hardware-Enforced Encryption</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center', color: '#d74937', fontWeight: 'bold'}}>AMD SEV (RAM + Disk)</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>None</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>Optional (complex setup)</td>
									</tr>
									<tr style={{backgroundColor: '#f9f9f9'}}>
										<td style={{padding: '12px', border: '1px solid #ddd', fontWeight: 'bold'}}>User-Controlled Encryption Keys</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center', color: '#d74937', fontWeight: 'bold'}}>Yes (exclusive control panel)</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>No</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>Manual configuration required</td>
									</tr>
									<tr>
										<td style={{padding: '12px', border: '1px solid #ddd', fontWeight: 'bold'}}>Protection from Host Access</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center', color: '#d74937', fontWeight: 'bold'}}>Complete (mathematically guaranteed)</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>None (host has full access)</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>Physical only (datacenter staff)</td>
									</tr>
									<tr style={{backgroundColor: '#f9f9f9'}}>
										<td style={{padding: '12px', border: '1px solid #ddd', fontWeight: 'bold'}}>Deployment Speed</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center', color: '#d74937', fontWeight: 'bold'}}>&lt; 60 seconds</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>&lt; 60 seconds</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>Hours to days</td>
									</tr>
									<tr>
										<td style={{padding: '12px', border: '1px solid #ddd', fontWeight: 'bold'}}>Scalability</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center', color: '#d74937', fontWeight: 'bold'}}>Instant (upgrade/downgrade)</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>Instant</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>Requires new hardware</td>
									</tr>
									<tr style={{backgroundColor: '#f9f9f9'}}>
										<td style={{padding: '12px', border: '1px solid #ddd', fontWeight: 'bold'}}>Performance</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center', color: '#d74937', fontWeight: 'bold'}}>Dedicated-class resources</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>Shared resources</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>Full dedicated resources</td>
									</tr>
									<tr>
										<td style={{padding: '12px', border: '1px solid #ddd', fontWeight: 'bold'}}>Data Sovereignty</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center', color: '#d74937', fontWeight: 'bold'}}>Swiss hosting + hardware encryption</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>Location only (no encryption)</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>Location only (manual setup)</td>
									</tr>
									<tr style={{backgroundColor: '#f9f9f9'}}>
										<td style={{padding: '12px', border: '1px solid #ddd', fontWeight: 'bold'}}>Price Point</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center', color: '#d74937', fontWeight: 'bold'}}>Dedicated server pricing</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>Budget-friendly</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>Premium pricing</td>
									</tr>
									<tr>
										<td style={{padding: '12px', border: '1px solid #ddd', fontWeight: 'bold'}}>Management Complexity</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center', color: '#d74937', fontWeight: 'bold'}}>Simple (automated encryption)</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>Simple</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>Complex (manual security setup)</td>
									</tr>
									<tr style={{backgroundColor: '#f9f9f9'}}>
										<td style={{padding: '12px', border: '1px solid #ddd', fontWeight: 'bold'}}>Zero-Trust Architecture</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center', color: '#d74937', fontWeight: 'bold'}}>Built-in (hardware level)</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>Not possible</td>
										<td style={{padding: '12px', border: '1px solid #ddd', textAlign: 'center'}}>Requires extensive configuration</td>
									</tr>
								</tbody>
							</table>
							<div style={{marginTop: '30px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '5px', textAlign: 'center'}}>
								<p style={{fontSize: '1.1em', fontStyle: 'italic', margin: 0}}>
									<strong>Some workloads must remain confidential at all times. Confidential servers are built precisely for that purpose.</strong>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default ComparisonTable;
